import { render, staticRenderFns } from "./factors.vue?vue&type=template&id=454663fc&scoped=true&lang=pug"
import script from "./factors.vue?vue&type=script&lang=js"
export * from "./factors.vue?vue&type=script&lang=js"
import style0 from "./factors.vue?vue&type=style&index=0&id=454663fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454663fc",
  null
  
)

export default component.exports